var browserGeoLocation_messages = angular.module('browserGeoLocationMessages', [])
    .constant('browserGeoLocationMessages', {
        'errors.location.unsupportedBrowser': 'Browser does not support location services',
        'errors.location.permissionDenied': 'You have rejected access to your location',
        'errors.location.positionUnavailable': 'Unable to determine your location',
        'errors.location.timeout': 'Service timeout has been reached'
    });

angular.module('mapApplication.services', ['browserGeoLocationMessages'])
    // Geocoding and reverse geocoding
    .factory('geocodeService', function ($q) {
        return {
            reverseAddress: function (lat, lng) {
                var deferred = $q.defer();
                var geo = new google.maps.Geocoder;
                var latlng = new google.maps.LatLng(lat, lng);

                geo.geocode({ 'latLng': latlng }, function (results, status) {
                    if (status === google.maps.GeocoderStatus.OK) {
                        var loc = { "latitude": 0, "longitude": 0 };
                        loc.formattedAddress = results[0].formatted_address;
                        deferred.resolve(loc);

                    } else {
                        deferred.reject(status);
                    }
                });

                return deferred.promise;
            },
            geocode: function (address) {
                var deferred = $q.defer();
                var geo = new google.maps.Geocoder;
                geo.geocode({ 'address': address, componentRestrictions: { 'country': 'US' } }, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        var loc = {};
                        loc.latitude = results[0].geometry.location.lat();
                        loc.longitude = results[0].geometry.location.lng();
                        loc.geometryLocation = angular.copy(results[0].geometry.location);
                        loc.formattedAddress = results[0].formatted_address;
                        deferred.resolve(loc);
                    } else {
                        deferred.reject(status);
                    }
                });

                return deferred.promise;
            }
        }

    })

    // Initializes Map
    // Creates/Clears pins
    // Adds event handlers to pins for on click. Adds the content
    .factory('googleMapService', function () {
        var map;
        var markers = [];
        var bankLocations = [];
        var infoWindow;
        var lastFocusedMarker;

        function initMap(center, zoom) {
            map = new google.maps.Map(document.getElementById('map'), {
                center: center,
                zoom: zoom,
                scrollwheel: false,
                styles: [
                    {
                        featureType: "poi", // Hide all other markers on the map
                        stylers: [{ visibility: "off" }],
                    }
                ]
            });
            infoWindow = new google.maps.InfoWindow();
            google.maps.event.addListener(map, 'click', function (e) {
                infoWindow.close();
            });
        }

        function drop() {
            clearMarkers();
            for (var i = 0; i < bankLocations.length; i++) {
                var location = bankLocations[i];
                var label = location.distanceRank.toString();

                var marker = new google.maps.Marker({
                    position: new google.maps.LatLng(location.latitude, location.longitude),
                    map: map,
                    animation: null,
                    icon: {
                        url: location.isFeeFreeAtm ? '/images/marker_feefree_atm.svg?v=2' : '/images/marker.svg?v=2',
                        labelOrigin: new google.maps.Point(14, 14)
                    },
                    label: {
                        text: label.toString(),
                        fontFamily: "Nunito, Helvetica, Arial, sans-serif",
                        fontSize: '15px',
                        fontWeight: "bold",
                        color: '#FFFFFF'
                    },
                    //optimized: false,
                    index: i
                });
                markers.push(marker);
                marker.addListener('click', function () {
                    var index = this.index

                    var locationEl = document.querySelector("[data-index='" + index + "']");
                    handleLocationSelect(locationEl);
                });
            }

        }

        function getInfoWindowContent(index) {
            var location = bankLocations[index];
            var services = [];
            if (location.isBranchLocation === true) {
                services.push("Branch");
            }
            if (location.isAtmLocation) {
                services.push(" ATM");
            }
            if (location.isFeeFreeAtm) {
                services.push(" Fee-free ATM");
            }
            if (location.isDriveUp) {
                services.push(" Drive-Up");
            }
            if (location.isBicycleDriveUp) {
                services.push(" Bicycle Drive-Up");
            }
            if (location.isCoinstar) {
                services.push(" Coinstar");
            }

            if (location.branchHours) {
                var branchHours = '<div class="branch-hours"><p class="no-mar"><strong>Branch Hours</strong></p>' + '<p>' + location.branchHours.replace("\n", "<br>") + '</p></div>';
            }
            else {
                var branchHours = '';
            }

            var linkAttrs = ' class="button" href="' + location.googleMapLink + '" target="_blank"';
            if (typeof getLinkAttributes === 'function') {
                var attrs = getLinkAttributes(location.googleMapLink);
                for (var i = 0; i < attrs.length; i++) {
                    var attr = attrs[i];
                    var val = '' + attr[1];
                    linkAttrs += ' ' + attr[0] + '="' + val.replace(/"/g, '&quot;') + '"';
                }
            }

            var headingMarkup = '';
            if (location.branchPageLinkUrl) {
                headingMarkup = '<h2 class="has-link"><a href="' + location.branchPageLinkUrl + '" aria-label="' + location.locationName + ' branch details">' + location.distanceRank + '. ' + location.locationName + '</a></h2>';
            }
            else {
                headingMarkup = '<h2>' + location.distanceRank + '. ' + location.locationName + '</h2>';
            }

            return '<div id="locationContent">' +
                '<div class="branch">' +
                headingMarkup +
                '<p><a href="' + location.googleMapLink + '" target="_blank" >' + location.streetAddress + '<br />' +
                location.city + ', ' + location.state + ' ' + location.zipCode + '</a></p>' +
                (location.phoneNumber ? '<p><a href="tel:' + location.phoneNumber.replace(/\D/g, '') + '" aria-label="branch phone number">' + location.phoneNumber + '</a></p>' : '') +
                '</div>' +
                branchHours +
                '<div class="branch-services"><p class="no-mar"><strong>Services</strong></p>' +
                '<p>' + services + '</p></div>' +
                '<div class="action-buttons"><a' + linkAttrs + '> Get directions</a>' +
                (location.branchScheduleAppointmentLinkUrl ? '<a class="button button--outline" href="' + location.branchScheduleAppointmentLinkUrl +'" onclick="return tt.launchWorkflow(this);" data-speed-bump="false" title="Schedule Appointment" data-sb-type="2" data-link-type="external" oncontextmenu="return false">Schedule an appointment</a>' : '') +
                '</div>' +
                (location.branchPageLinkUrl ? '<p class="no-mar"><a href="' + location.branchPageLinkUrl + '" aria-label="More info about this branch">Branch details</a></p>' : '') +
                '</div>';

        }

        function clearMarkers() {
            for (var i = 0; i < markers.length; i++) {
                markers[i].setMap(null);
            }
            markers = [];
        }

        function resetBounds() {
            var accumulatedBounds = new google.maps.LatLngBounds();
            for (var i = 0; i < markers.length; i++) {
                accumulatedBounds.extend(markers[i].getPosition());
            }

            map.fitBounds(accumulatedBounds, 0);
        }

        // Apply default bounds when bounds not provided
        function applyPanZoom(bounds, zoom) {
            map.setZoom(zoom);
            map.fitBounds(bounds, 0);
        }

        function panToMarkerAtIndex(index, zoom, forceZoom) {
            if (markers[index]) {
                if (zoom && (forceZoom || map.zoom < 11)) {
                    // Only zoom in if not already zoomed
                    map.setZoom(zoom);
                }
                
                map.panTo(markers[index].position);
                setActiveMarkerAtIndex(index);
            }
        }

        function setActiveMarkerAtIndex(index) {
            var marker = markers[index];

            if (lastFocusedMarker) {
                lastFocusedMarker.icon.url = lastFocusedMarker.icon.prevIconUrl ?? 'https://www.oneazcu.com/media/pmyadsud/marker.svg' ;
                lastFocusedMarker.setZIndex();
            }
            if (marker) {
                lastFocusedMarker = marker;
                marker.icon.prevIconUrl = marker.icon.url;
                marker.icon.url = 'https://www.oneazcu.com/media/b4qneqpy/marker_active.svg';
                marker.setZIndex(100);
            }
        }

        function handleLocationSelect(locationEl) {
            var index = parseInt(locationEl.attributes['data-index'].value);

            if (window.matchMedia('(min-width: 1024px)').matches) {
                panToMarkerAtIndex(index, 11);
                document.getElementById('scrollingLocationsSection').scrollTop = locationEl.offsetTop - 8;
            } else {
                setActiveMarkerAtIndex(index);
                infoWindow.close();
                infoWindow.setContent(getInfoWindowContent(index));
                infoWindow.open(map, markers[index]);
            }
        }

        return {
            initMap: initMap,
            drop: drop,
            clearMarkers: clearMarkers,
            resetBounds: resetBounds,
            setBankLocations: function (locations) {
                bankLocations = locations;
            },
            applyPanZoom: applyPanZoom,
            panToMarkerAtIndex: panToMarkerAtIndex,
            setActiveMarkerAtIndex: setActiveMarkerAtIndex,
            handleLocationSelect: handleLocationSelect,
            closeInfoWindow: function () {
                infoWindow.close();
            }

        }
    })

    // uses built in Navigator.geolocation to use users current location
    .factory('browserGeoLocationService', ['$q', '$rootScope', '$window', 'browserGeoLocationMessages',
        function ($q, $rootScope, $window, browserGeoLocationMessages) {
            return {
                getLocation: function () {
                    var deferred = $q.defer();
                    var options = {
                        enableHighAccuracy: true,
                        timeout: 15000,
                        maximumAge: 0
                    };

                    if ($window.navigator && $window.navigator.geolocation) {
                        $window.navigator.geolocation.getCurrentPosition(function (position) {
                            //  $rootScope.$apply(function() {
                            deferred.resolve(position);
                            // });
                        }, function (error) {
                            switch (error.code) {
                                case 1:
                                    $rootScope.$broadcast('error', browserGeoLocationMessages['errors.location.permissionDenied']);
                                    // $rootScope.$apply(function() {
                                    deferred.reject(browserGeoLocationMessages['errors.location.permissionDenied']);
                                    //});
                                    break;
                                case 2:
                                    $rootScope.$broadcast('error', browserGeoLocationMessages['errors.location.positionUnavailable']);
                                    //$rootScope.$apply(function() {
                                    deferred.reject(browserGeoLocationMessages['errors.location.positionUnavailable']);
                                    //});
                                    break;
                                case 3:
                                    $rootScope.$broadcast('error', browserGeoLocationMessages['errors.location.timeout']);
                                    //$rootScope.$apply(function() {
                                    deferred.reject(browserGeoLocationMessages['errors.location.timeout']);
                                    //});
                                    break;
                            }
                        }, options);
                    } else {
                        $rootScope.$broadcast('error', browserGeoLocationMessages['errors.location.unsupportedBrowser']);
                        // $rootScope.$apply(function() {
                        deferred.reject(browserGeoLocationMessages['errors.location.unsupportedBrowser']);
                        // });
                    }
                    return deferred.promise;
                }

            }
        }])

    ;

